import React, { useMemo, useState } from "react";
import NoData from "assets/svgs/no_data/NoData";
import { Modal } from "react-bootstrap";
import { CloseButton, Button } from "react-bootstrap";
import { DatePicker } from "antd";
import { distributeRevenueToDate, fourPlaceHolder } from "modules/utilities/utility";
import {useCaseManagement} from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import CardDiv from "modules/common/card-div/CardDiv";

function SalesTable({ tableData, isLoading, refresh, setRefresh }) {
  const [medId, setMedId] = useState("");
  const [modalShow, setModalShow] = React.useState(false);
  const [revenue, setRevenue] = useState(null);
  const [rangeData, setRangeData] = useState(null);

  const { RangePicker } = DatePicker;
  const { postSalesTargets}=useCaseManagement();
  const {setToaster}=useToast();

  const handleEdit = (item) => {
    setMedId(item?.key);
    setRangeData(item);
    setModalShow(true);
  };

  const [dateRange, setDateRange] = useState([null, null]);

  const handleDateChange = (dates) => {
    setDateRange(dates);
  };

  const handleRevenue = (e) => {
    setRevenue(e.target.value);
  };

  const handleSave = (e) => {
    e.preventDefault();
    const data=distributeRevenueToDate(revenue, dateRange);
    const promiseData=data?.map((item)=>{
      return {revenue: item.revenue,
        target_date: item.target_date.toISOString()}
    })
    postSalesTargets(medId,promiseData, setToaster, refresh, setRefresh)
    setModalShow(false);
  };


  const progressCount = useMemo(() => {
    if (!rangeData) return 0.0;
    return parseFloat(
      (rangeData.fullfilled_calls / rangeData.target_calls) * 100
    ).toFixed(2);
  }, [rangeData]);

  const tableHeader = ["Name", "Targets Calls", "Target Actions", "Action"];

  return (
    <CardDiv title={<div className="fs-2">Sales Management</div>}
   component={ <div>
      <div
        className=" rounded  w-100 shadow"
        style={{ minHeight: "20vh" }}
      >
        <table className="table px-2 rounded table-head table-hover">
          <thead className="pb-0  rounded-top text-secondary">
            <tr className="border rounded-top d-flex">
              {tableHeader.map((header) => (
                <th
                  className="table-column flex-1 text-black fw-bold mt-2  align-top"
                  key={header}
                >
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="w-100 rounded-bottom">
            {isLoading ? (
              <tr>
                {fourPlaceHolder()}
              </tr>
            ) : tableData?.length !== 0 &&
              isLoading === false &&
              Array.isArray(tableData) &&
              tableData?.length > 0 ? (
              tableData?.map((item, index) => {
                return (
                  <tr
                    id="table-row-value"
                    className={`d-flex border border-top-0 bg-white align-items-center${
                      index === tableData.length - 1 ? `rounded-bottom` : ``
                    }`}
                    key={item?.rep_name}
                  >
                    <td className="flex-1 m-0 text-black fw-bold">
                      {item?.rep_name}
                    </td>
                    <td className="flex-1 m-0 text-black fw-bold">
                      {item?.fullfilled_calls || item?.target_calls ? (
                        <div>
                          {" "}
                          {item?.fullfilled_calls} / {item?.target_calls}
                        </div>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td
                      className="flex-1 m-0 text-black fw-bold"
                    >
                      {item?.fullfilled_orders || item?.target_orders ? (
                        <div>
                          {" "}
                          {item?.fullfilled_orders} / {item?.target_orders}
                        </div>
                      ) : (
                        "-"
                      )}
                    </td>
                    <td
                      className="flex-1 m-0 text-primary fw-bold cursor-pointer"
                      onClick={() => handleEdit(item)}
                    >
                      Edit
                    </td>
                  </tr>
                );
              })
            ) : tableData?.length === 0 && isLoading === false ? (
              <div className="w-100 d-flex justify-content-center border bg-white">
                <h3 className="p-3 ">Data is not Available</h3>
                <span>
                  <NoData />
                </span>
              </div>
            ) : (
              ""
            )}
          </tbody>
        </table>
      </div>
      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
           Edit Rep Target
          </Modal.Title>
          <CloseButton
            className="btn btn-circle btn-sm transition-base p-0"
            onClick={() => setModalShow(false)}
          />
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSave}>
          <div className="form-outline">
          <label className="form-label" htmlFor="typeNumber"><span className="text-danger me-1 fs-1 mt-4">*</span>Order Target</label>
            <input
              type="number"
              id="typeNumber"
              className="form-control"
              onChange={handleRevenue}
              required
            />
          </div>
          <div className="mt-2">
          <label htmlFor="dateRangePicker"><span className="fs-1 text-danger me-2">*</span>Select Date Range:</label>
          <RangePicker
            id="dateRangePicker"
            style={{ width: "100%" }}
            size="middle"
            onChange={handleDateChange}
            required
          />
           </div>
          <div className="float-end mt-3">
            <button className="btn btn-primary" type="submit">
              Save
            </button>
          </div>
          </form>
          <div className="d-flex flex-column gap-3 mt-3">
            <div className="d-flex  gap-2">
              <label htmlFor="progress">
                <div className="fw-bold fs-1">Current Progress :</div>
              </label>
              <input
                type="range"
                id="progress"
                name="progress"
                min={0}
                max={100}
                defaultValue={isNaN(progressCount) ? 0.0 : progressCount}
                className="mt-n2"
              />
              <div className="fw-bold">{isNaN(progressCount) ? 0.0 : progressCount }%</div>
            </div>

            <div className="d-flex align-items-center gap-2">
              <div className="fw-bold fs-1 col-4">Completed Calls :</div>
              <div className="fs-1 col-1 text-center pe-2">{rangeData?.fullfilled_calls}</div>
            </div>

            <div className="d-flex gap-2">
              <div className="fs-1 fw-bold">Completed Orders :</div>
              <div className="fs-1">{rangeData?.fullfilled_orders}</div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={() => setModalShow(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </div>}/>
  );
}

export default SalesTable;
